import { render, staticRenderFns } from "./SuppliersTab.vue?vue&type=template&id=8adb5900&scoped=true&"
import script from "./SuppliersTab.vue?vue&type=script&lang=js&"
export * from "./SuppliersTab.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersTab.vue?vue&type=style&index=0&id=8adb5900&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adb5900",
  null
  
)

export default component.exports